export const names = {
  satSections: {
    math: 'Math',
    'reading and writing': 'Reading and Writing',
  },
  answerType: {
    MultipleChoice: 'Multiple Choice',
    SingleChoice: 'Multiple Choice', // Customer requirement. It's not a dev mistake
    TextEntry: 'Student response',
  },
};
